import { render, staticRenderFns } from "./ProductImageRemoveBGModal.vue?vue&type=template&id=2baee156"
import script from "./ProductImageRemoveBGModal.vue?vue&type=script&lang=js"
export * from "./ProductImageRemoveBGModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2baee156')) {
      api.createRecord('2baee156', component.options)
    } else {
      api.reload('2baee156', component.options)
    }
    module.hot.accept("./ProductImageRemoveBGModal.vue?vue&type=template&id=2baee156", function () {
      api.rerender('2baee156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/ProductImageRemoveBGModal.vue"
export default component.exports